export const sum = (items, getValue) => items.reduce((total, item) => total + getValue(item), 0);

export const weightedAvg = (items, getValue, getWeight) => {
  if (!items.length) return 0;
  const totalWeight = sum(items, getWeight);
  if (!totalWeight) return sum(items, getValue) / items.length;
  return sum(items, (item) => getValue(item) * getWeight(item)) / totalWeight;
};

export const optionalWeightedAvg = (items, getValue, getWeight) => {
  const withValue = items.filter((item) => getValue(item) !== null);
  return withValue.length ? weightedAvg(withValue, getValue, getWeight) : null;
};

export const percentChange = (current, previous) => (previous ? (current / previous - 1) * 100 : null);

export const groupBy = (items, getKey) => {
  const groups = new Map();
  items.forEach((item) => {
    const key = getKey(item);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(item);
  });
  return groups;
};